import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin, FileText, Shield, Scale } from 'lucide-react';

export default function MarketingFooter() {
  const navigate = useNavigate();
  return (
    <footer className="border-t border-gray-200 bg-white" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <img src="/logo.png" alt="LaizyLeads" className="h-8 w-auto" />
              <span className="font-semibold text-lg tracking-tight text-gray-900">LaizyLeads</span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed">
              KI-gestützte B2B-Leadgenerierung. Hochwertige B2B Leads statt Massenkontakte — gezielt passende Unternehmen finden und automatisiert neue Kunden gewinnen.
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Produkt</h4>
            <ul className="space-y-2.5">
              <li><Link to="/leistungen" className="text-sm text-gray-500 hover:text-gray-700 transition-colors">Leistungen</Link></li>
              <li><Link to="/branchen" className="text-sm text-gray-500 hover:text-gray-700 transition-colors">Branchen</Link></li>
              <li><Link to="/case-studies" className="text-sm text-gray-500 hover:text-gray-700 transition-colors">Case Studies</Link></li>
              <li><button onClick={() => navigate('/login')} className="text-sm text-gray-500 hover:text-gray-700 transition-colors">Anmelden</button></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Unternehmen</h4>
            <ul className="space-y-2.5">
              <li><Link to="/ueber-uns" className="text-sm text-gray-500 hover:text-gray-700 transition-colors">Über uns</Link></li>
              <li><Link to="/kontakt" className="text-sm text-gray-500 hover:text-gray-700 transition-colors">Kontakt</Link></li>
              <li><a href="https://www.laizyones.de" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-gray-700 transition-colors">Laizyones</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Kontakt</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-gray-500"><Mail className="w-3.5 h-3.5" /> info@laizyones.de</li>
              <li className="flex items-center gap-2 text-sm text-gray-500"><Phone className="w-3.5 h-3.5" /> 0179 7615911</li>
              <li className="flex items-center gap-2 text-sm text-gray-500"><MapPin className="w-3.5 h-3.5" /> Ferdinand-Lentjes-Str. 32, 39167 Wellen</li>
            </ul>
          </div>
        </div>

        {/* Legal sections */}
        <div className="space-y-10 pt-10 border-t border-gray-200">
          <div data-testid="impressum-section">
            <h4 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
              <FileText className="w-4 h-4 text-gray-400" /> Impressum
            </h4>
            <div className="text-xs text-gray-500 leading-relaxed space-y-1">
              <p>Angaben gemäß § 5 TMG: Laizyones, Einzelunternehmen, Inhaber: David Ehrle, Ferdinand-Lentjes-Straße 32, 39167 Wellen, Deutschland.</p>
              <p>Das vollständige Impressum finden Sie unter: <a href="https://laizyones.de/impressum" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:text-emerald-700 underline">www.laizyones.de/impressum</a></p>
            </div>
          </div>
          <div data-testid="agb-section">
            <h4 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
              <Scale className="w-4 h-4 text-gray-400" /> Allgemeine Geschäftsbedingungen (AGB)
            </h4>
            <div className="text-xs text-gray-500 leading-relaxed space-y-1">
              <p>Es gelten die Allgemeinen Geschäftsbedingungen der Laizyones. LaizyLeads ist ein Produkt der Laizyones.</p>
              <p>Die vollständigen AGB finden Sie unter: <a href="https://laizyones.de/agb" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:text-emerald-700 underline">www.laizyones.de/agb</a></p>
            </div>
          </div>
          <div data-testid="datenschutz-section">
            <h4 className="text-sm font-semibold text-gray-900 mb-2 flex items-center gap-2">
              <Shield className="w-4 h-4 text-gray-400" /> Datenschutzerklärung
            </h4>
            <div className="text-xs text-gray-500 leading-relaxed space-y-1">
              <p>Informationen zum Datenschutz und zur Verarbeitung personenbezogener Daten finden Sie in der Datenschutzerklärung der Laizyones:</p>
              <p><a href="https://laizyones.de/datenschutz" target="_blank" rel="noopener noreferrer" className="text-emerald-600 hover:text-emerald-700 underline">www.laizyones.de/datenschutz</a></p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-10 mt-10 border-t border-gray-200">
          <p className="text-xs text-gray-400">&copy; 2026 <a href="https://www.laizyones.de" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600">Laizyones</a> — LaizyLeads ist ein Produkt der Laizyones. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
}
